import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const BasicAlt = loadable(() => import('./BasicAlt'), {});
export const BasicTicket = loadable(() => import('./BasicTicket'), {});
export const FinancialWithdrawalLine = loadable(() => import('./FinancialWithdrawalLine'), {});
export const ProductOptionType = loadable(() => import('./ProductOptionType'), {});
export const PaymentStatus = loadable(() => import('./PaymentStatus'), {});
